<style scoped lang="less">
	// /deep/ .el-table__row{
	// 	background-color: #dcdc8f;
	// }
	// /deep/ .el-table__row--level-1{
	// 	background-color: #44d5dc !important;
	// }
	// /deep/ .el-table__row--level-2{
	// 	background-color: #b4eb9d !important;
	// }
	// /deep/ .el-table__row--level-3{
	// 	background-color: #95ebd9 !important;
	// }


	.elecenter {
		display: block;
		width: 100%;
		text-align: center;
	}

	.oderlookds {
		color: #fff;
		border-radius: 1rem;
		text-align: center;
	}

	.oderlookd {
		border-radius: 1rem;
		text-align: center;

	}

	/deep/ .el-dialog__header {
		padding: 14px 19px 10px;
		background: #05A34A;
		color: #fff;
		font-size: 1.2rem;

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
			font-size: 1.4rem;

		}

		.el-dialog__title {
			color: #fff !important;
		}

		.dialog-header-title {
			span {
				margin-left: 0.6rem;
			}
		}
	}

	.oder {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.orderslist {
			width: 40%;
			margin-right: 2%;

			.orderstitle {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0.6rem;
				height: 2.5rem;
				background: #47C28F;
				box-sizing: border-box;

				p {
					font-size: 1rem;
					color: #fff;
				}

				p:last-child {
					span {
						margin: 0 0.6rem;
						font-size: 1.2rem;
						font-weight: 800;
					}
				}
			}

			.ordertree {
				// padding: 0 1rem;
				width: 100%;
				box-sizing: border-box;

				.el-tree {
					padding: 1rem 1.4rem;
				}
			}
		}

		.orderstable {
			// margin-top: 1rem;
			padding: 1rem;
			width: 100%;
			background-color: #fff;
			border-top: 4px solid #22AF47;
			border-radius: 2px;

			.oderlookds {
				background-color: #F41127;
			}

			.oderlookd {
				padding: 0.1rem;
				width: 4rem;
				background: rgb(78, 192, 204);
				color: rgb(255, 255, 255);
				margin: 0 auto;
				border-radius: 1rem;
			}

			.tabslis {
				/deep/ & ::-webkit-scrollbar {
					width: 5px;
					height: 8px;
					background: linear-gradient(to right, #2e61bf, #60c363);
				}

				& ::-webkit-scrollbar {
					width: 10px;
					height: 5px;
					// background: red;
				}

				& ::-webkit-scrollbar-track {
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
					border-radius: 0;
					background: rgba(0, 0, 0, 0.1);
				}

				/deep/ .el-table {
					th,
					td {
						// text-align: center;

					}

					td {
						button {
							color: #fff;
							border-radius: 5px;
						}

						.looking {
							background: #0D6EFD;
							margin-left: 10px;

							span {
								font-size: 0.6rem;
								font-weight: 800;
							}
						}

						.looking:hover {
							background: #0b67e6;
						}


						// .giveempower {
						// 	background: #FF8300;

						// 	span {
						// 		font-size: 0.6rem;
						// 	}
						// }



						.edit {
							background: #17A001;

							span {
								font-size: 0.6rem;
							}
						}

						.edit:hover {
							background: #1fcf00;
						}

						.delete {
							background: #ec0f25;

							span {
								font-size: 0.6rem;
							}
						}

						.delete:hover {
							background: #ff1128;
						}


					}

				}



			}

			.tabsnum {
				height: 4rem;
				display: flex;
				align-items: center;
				justify-content: space-between;

				p {
					color: #333;
				}

				.elpagian {
					margin-right: 1rem;
				}

				/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
					background: linear-gradient(to right, #018761, #39B170);
					// color: #FFF;
				}


			}

			.schooltitle {
				font-size: 1.2rem;
				color: #22AF47;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #ccc;
				padding-bottom: 1rem;
				position: relative;

				button {
					padding: 0.4rem;
					background: #FE8930;
					font-size: 0.6rem;
					border-radius: 3px;
					padding: 0.6rem 1.2rem;
					position: absolute;
					right: 1%;
					color: #fff;

					span {
						color: #fff;
						margin-right: 0.2rem;
						font-weight: 900;

					}
				}

				span.el-icon-s-management {
					display: block;
					padding: 0.4rem;
					border-radius: 50%;
					font-size: 1rem;
					margin-right: 0.4rem;
					box-sizing: border-box;
					background: #22AF47;
					color: #fff;
				}
			}
		}


	}

	/* 动画 */
	@keyframes danchu {
		from {
			transform: translateX(-100%);
			opacity: 0;
		}

		to {
			opacity: 1;
			transform: translateX(0px);
		}
	}

	.v-enter-active {
		animation: danchu 1s linear;
	}

	.v-leave-active {
		animation: danchu 1s linear reverse;
	}



	.looking {
		background: #0D6EFD;
		margin-left: 10px;

		span {
			color: #fff;
		}

	}

	.looking:hover {
		background: #0b67e6;

	}


	.edit {
		background: #17A001;

		span {
			color: #fff;
		}

		// span {
		// 	font-size: 1.2rem;
		// }
	}

	.edit:hover {
		background: #1fcf00;
	}

	.delete {
		background: #ec0f25;

		span {
			color: #fff;
		}

		// span {
		// 	font-size: 1.2rem;
		// }
	}

	.delete:hover {
		background: #ff1128;
	}

	input {
		border: 1px solid #ccc;
		height: 100%;
		padding: 0.4rem;
		border-radius: 3px;
	}

	/deep/ .tablestitle {
		color: #333;

		.cell {
			font-weight: 600 !important;
		}

		// font-size: 1rem;
	}
</style>
<template>

	<!-- <transition>
		<div class="orderslist" v-show="isShow">
			<div class="orderstitle">
				<p>
					<span class="el-icon-s-fold"></span>
					菜单树
				</p>
				<p>
					<span class="el-icon-plus"></span>
					<span class="el-icon-refresh"></span>
				</p>
			</div>
			<div class="ordertree">
				<el-tree :data="treedata" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
			</div>
		</div>
	</transition> -->
	<div>
		<titles titlename="菜单管理" titlecontent="这里可以管理菜单" :mbx="paths"></titles>
		<div class="oder">
			<el-dialog :show-close="false" title="添加菜单" :visible.sync="dialogVisible1" width="50%" :before-close="handleClose">
				<el-descriptions class="margin-top" :column="2" border>
					<el-descriptions-item>
						<template slot="label">
							菜单名<span style="color: red;">*</span>
						</template>
						<input type="text" placeholder="请输入菜单名" v-model="MenuListobjs.mu_name_cn">
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							菜单编号<span style="color: red;">*</span>
						</template>
						<input type="text" placeholder="请输入菜单编号" v-model="MenuListobjs.mu_name_en">
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							菜单路径
						</template>
						<input type="text" placeholder="请输入菜单路径" v-model="MenuListobjs.mu_menuPath">
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							排序
						</template>
						<input type="text" placeholder="请输入菜单排序" v-model="MenuListobjs.mu_sort">
					</el-descriptions-item>
					<el-descriptions-item span="3">
						<template slot="label">
							菜单图标网站选择
						</template>
						<!-- <p @click="goiconCopy()" style="cursor: pointer;color: #0284FF;text-decoration: underline;">
							https://element.eleme.cn/#/zh-CN/component/icon#tu-biao-ji-he</p> -->
							<p @click="goiconCopy()" style="cursor: pointer;color: #0284FF;text-decoration: underline;">
								/bs/icons</p>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							菜单图标
						</template>
						<input type="text" placeholder="请将复制的图标名字粘贴到这里" v-model="MenuListobjs.mu_icon">
					</el-descriptions-item>

					<el-descriptions-item>
						<template slot="label">
							菜单状态
						</template>
						<el-radio v-model="radio" label="1">可见</el-radio>
						<el-radio v-model="radio" label="0">不可见</el-radio>
					</el-descriptions-item>

					<el-descriptions-item span="3">
						<template slot="label">
							所属上级菜单
						</template>
						<el-cascader @change="cdcahnges()" v-model="cdvalue" :options="cdoptions"
							:props="{checkStrictly: true ,label:'mu_name_cn',value:'mu_guid',children:'MenuParent'}"
							clearable></el-cascader>
					</el-descriptions-item>
				</el-descriptions>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible1 = false">取 消</el-button>
					<el-button type="primary" @click="editxpri1()">确 定</el-button>
				</span>
			</el-dialog>




			<el-dialog :show-close="false" :title="titlefs" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
				<div v-if="looins==1">
					<el-descriptions class="margin-top" :column="2" border>
						<el-descriptions-item>
							<template slot="label">
								菜单名
							</template>
							{{MenuListobj.mu_name_cn}}
							<!-- <input type="text" placeholder="请输入菜单名" v-model="" -->
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								菜单编号
							</template>
							{{MenuListobj.mu_name_en}}
							<!-- <input type="text" placeholder="请输入菜单编号" v-model=""> -->
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								菜单路径
							</template>
							{{MenuListobj.mu_menuPath}}
							<!-- <input type="text" placeholder="请输入菜单路径" v-model=""> -->
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								排序
							</template>
							{{MenuListobj.mu_sort}}
							<!-- <input type="text" placeholder="请输入菜单排序" v-model=""> -->
						</el-descriptions-item>

						<el-descriptions-item>
							<template slot="label">
								菜单图标
							</template>
							<span :class="MenuListobj.mu_icon"></span>
						</el-descriptions-item>

						<el-descriptions-item>
							<template slot="label">
								菜单状态
							</template>
							{{MenuListobj.mu_enable ? '可见' :　'不可见'}}
						</el-descriptions-item>
					</el-descriptions>
				</div>

				<div v-if="looins==2">
					<el-descriptions class="margin-top" :column="2" border>
						<el-descriptions-item>
							<template slot="label">
								菜单名<span style="color: red;">*</span>
							</template>
							<input type="text" placeholder="请输入菜单名" v-model="MenuListobj.mu_name_cn">
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								菜单编号<span style="color: red;">*</span>
							</template>
							<input type="text" placeholder="请输入菜单编号" v-model="MenuListobj.mu_name_en">
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								菜单路径
							</template>
							<input type="text" placeholder="请输入菜单路径" v-model="MenuListobj.mu_menuPath">
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								排序
							</template>
							<input type="text" placeholder="请输入菜单排序" v-model="MenuListobj.mu_sort">
						</el-descriptions-item>
						<el-descriptions-item span="3">
							<template slot="label">
								菜单图标网站选择
							</template>
							<p @click="goiconCopy()" style="cursor: pointer;color: #0284FF;text-decoration: underline;">
								/bs/icons</p>
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								菜单图标
							</template>
							<input type="text" placeholder="请将复制的图标名字粘贴到这里" v-model="MenuListobj.mu_icon">
						</el-descriptions-item>

						<el-descriptions-item>
							<template slot="label">
								菜单状态
							</template>
							<el-radio v-model="MenuListobj.mu_enable" :label="true">可见</el-radio>
							<el-radio v-model="MenuListobj.mu_enable" :label="false">不可见</el-radio>
						</el-descriptions-item>

						<el-descriptions-item span="3">
							<template slot="label">
								所属上级菜单
							</template>
							<el-cascader @change="cdcahnges1()" v-model="MenuListobj.mu_parentGuid" :options="cdoptions"
								:props="{checkStrictly: true ,label:'mu_name_cn',value:'mu_guid',children:'MenuParent'}"
								clearable></el-cascader>
						</el-descriptions-item>

					</el-descriptions>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button　v-if="looins==2" type="primary" @click="editxpri()" v-preventReClick>确 定</el-button>
					<el-button　v-if="looins==1" type="primary" @click="dialogVisible = false">确 定</el-button>
				</span>
			</el-dialog>


			<div class="orderstable">
				<p class="schooltitle">
					<span class="el-icon-s-management"></span>
					<span>菜单数据列表</span>
					<el-tooltip class="item" effect="dark" content="点击添加菜单" placement="left-end">
						<button @click="openordersetting()">
							<span class="icon-user-follow"></span>
							添加新菜单
						</button>
					</el-tooltip>

				</p>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%"
							row-key="mu_guid" :tree-props="{children: 'MenuParent'}">
							<!-- <el-table-column fixed type="selection" width="55">
							</el-table-column> -->
							<el-table-column prop="mu_name_cn" label="名称">
							</el-table-column>
							<el-table-column prop="mu_name_en" label="菜单缩写" align="center">
							</el-table-column>
							<el-table-column prop="mu_sort" label="菜单排序" align="center">
							</el-table-column>
							<el-table-column prop="mu_menuPath" label="菜单路径" align="center">
							</el-table-column>
							<el-table-column prop="mu_icon" label="菜单图标" align="center">
								<template slot-scope="scope">
									<span class="elecenter" :class="scope.row.mu_icon"></span>
								</template>
							</el-table-column>
							<el-table-column label="是否可见" width="100">
								<template slot-scope="scope">
									<p class="oderlookd" v-if="scope.row.mu_enable==true">
										可见
									</p>
									<p class="oderlookds" v-if="scope.row.mu_enable==false">
										不可见
									</p>
								</template>
							</el-table-column>
							<el-table-column fixed="right" label="操作" width="300">
								<template slot-scope="scope">
									<div class="userusec d-sm-none d-md-block">
										<el-tooltip class="item" effect="dark" content="查看" placement="top">
											<el-button size="small" :class="'looking'" @click="looginmun(scope.row)">
												<span class="el-icon-view" style="color: #fff;"></span>
											</el-button>
										</el-tooltip>
										<el-button size="small" @click="handleClick(scope.row)" class="edit">
											<el-tooltip class="item" effect="dark" content="编辑" placement="top">
												<span class="fas fa-eye-dropper" style="color: #fff;"></span>
											</el-tooltip>

										</el-button>
										<el-button size="small" class="delete" @click="tabledeletes($event,scope.row)">
											<el-tooltip class="item" effect="dark" content="删除" placement="bottom">
												<span class="el-icon-delete" style="color: #fff;"></span>
											</el-tooltip>
										</el-button>
										<el-button size="small" class="delete" style="background-color: #FE8930;" @click="tableapp(scope.row)">
											<el-tooltip class="item" effect="dark" content="添加子菜单" placement="bottom">
												<span class="el-icon-circle-plus-outline" style="color: #fff;"></span>
											</el-tooltip>
										</el-button>
									</div>
									<div class="userusec d-sm-block d-md-none">
										<el-dropdown trigger="click">
											<p class="el-dropdown-link">
												···
											</p>
											<el-dropdown-menu slot="dropdown">
												<el-button size="small" :class="'looking'"
													@click="looginmun(scope.row)">
													<el-tooltip class="item" effect="dark" content="查看" placement="top">
														<span class="el-icon-view" style="color: #fff;"></span>
													</el-tooltip>
												</el-button>
												<el-button size="small" @click="handleClick(scope.row)" class="edit">
													<el-tooltip class="item" effect="dark" content="编辑"
														placement="bottom">
														<span class="fas fa-eye-dropper" style="color: #fff;"></span>
													</el-tooltip>

												</el-button>
												<el-button size="small" class="delete"
													@click="tabledeletes($event,scope.row)">
													<el-tooltip class="item" effect="dark" content="删除" placement="top">
														<span class="el-icon-delete" style="color: #fff;"></span>
													</el-tooltip>
												</el-button>
												<el-button size="small" style="background-color: #FE8930;" class="delete" @click="tableapp(scope.row)">
													<el-tooltip class="item" effect="dark" content="添加子菜单" placement="bottom">
														<span class="el-icon-circle-plus-outline" style="color: #fff;"></span>
													</el-tooltip>
												</el-button>
												
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>

				</div>

				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{pagesobj.pageSize}}</span>
						,共
						<span>{{pagesobj.maxpages}}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination @current-change="changepage" background layout="prev, pager, next"
							:page-size="pagesobj.pageSize" :total="pagesobj.maxpages">
						</el-pagination>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import sidebarMenu from "@/components/sidebar/SidebarMenu.vue"
	import {
		getPcdageMenuList,
		getcdMenuSingle,
		getMenuInsertOrEdit,
		AuthoriyMenuDeleteList,
		AuthoriyGetMenuList
	} from "@/request/api/mange/mange.js"
	
	import AppOptions from '@/config/AppOptions.vue';

	export default {
		data() {
			return {
				// 菜单状态
				radio: "1",
				dialogVisible1: false,
				cdvalue: "111",
				cdvalues: "",
				cdoptions: [],
				// 修改
				sizeForm: {
					name: '',
					nameen: "",
					region: '',
					resource: ''

				},
				pagesobj: {
					pageIndex: 1,
					pageSize: 10,
					pro_name: "",
					maxpages: 10,
					mu_parentGuid: "",
					mu_name_cn: ""
				},
				MenuListobj: {},
				dialogVisible: false,
				titlefs: "菜单查看",
				// table表格
				tableData: [{
					orderid: 1,
					name: "系统三级菜单1",
					ordertype: "类型1",
					orderthing: "点击事件",
					orderlink: "http://www.hngtsd.net",
					orderlooking: 1
				}],

				// 动画显示隐藏
				isShow: false,
				// 树节点
				treedata: [],
				defaultProps: {
					children: 'children',
					label: 'title'
				},
				// 标题组件
				paths: [{
					path: "/qitamanage/menumange",
					name: "菜单管理"
				}],
				looins: 0,
				// 添加菜单
				MenuListobjs: {
					mu_guid: "",
					mu_name_cn: "",
					mu_name_en: "",
					mu_menuPath: "",
					mu_parentGuid: "",
					mu_enable: "",
					mu_icon: "",
					mu_sort: "1",
					mu_affiliation: "综合实训管理系统",
				}

			}
		},
		beforeMount() {
			this.getnumanto()
		},
		created() {
			AppOptions.appEmpty = false;
		},
		mounted() {
			// console.log(sidebarMenu)
			this.treedata = sidebarMenu
			this.getmunelist()
		},
		methods: {
			// 添加子菜单
			tableapp(e){
				// console.log(e)
				this.dialogVisible1 = true
				this.cdvalue = e.mu_guid
				this.MenuListobjs.mu_parentGuid = e.mu_guid
				this.MenuListobjs.mu_menuPath = e.mu_menuPath
			}, 
			
			
			// 获取菜单不分页
			getnumanto() {
				AuthoriyGetMenuList().then(res => {
					// console.log(res)
					this.cdoptions = res.data.data
					let cdobj = {
						mu_guid: "111",
						mu_name_cn: "最高菜单列"
					}
					this.cdoptions.unshift(cdobj)
				})
			},

			cdcahnges1() {
				// console.log(this.MenuListobj.mu_parentGuid)
				let cdvalue = this.MenuListobj.mu_parentGuid[this.MenuListobj.mu_parentGuid.length - 1]

				this.MenuListobj.mu_parentGuid = cdvalue
			},
			cdcahnges() {
				// console.log(this.cdvalue)
				let cdvalue = this.cdvalue[this.cdvalue.length - 1]

				this.MenuListobjs.mu_parentGuid = cdvalue
			},
			// 去菜单图标库
			goiconCopy() {
				// window.open("https://element.eleme.cn/#/zh-CN/component/icon#tu-biao-ji-he", '_blank')				
				let {href} = this.$router.resolve({
					path:'/bs/icons',
					query:{undefined}
				});
				window.open(href,'_blank');
			},

			changepage(val) {
				this.pagesobj.pageIndex = val
				this.getmunelist()
			},

			// 编辑数据
			handleClick(e) {
				this.getnumanto()
				// console.log(e)
				this.MenuListobj = JSON.parse(JSON.stringify(e))
				this.titlefs = e.mu_affiliation + "菜单"
				this.looins = 2
				this.dialogVisible = true
				this.MenuListobj.mu_parentGuid = this.MenuListobj.mu_parentGuid == "" ? ["111"] : this.MenuListobj
					.mu_parentGuid
				// console.log(this.MenuListobj)
			},
			editxpri1() {
				let MenuListobjs = {
					mu_guid: "",
					mu_name_cn: this.MenuListobjs.mu_name_cn,
					mu_name_en: this.MenuListobjs.mu_name_en,
					mu_menuPath: this.MenuListobjs.mu_menuPath,
					mu_parentGuid: this.MenuListobjs.mu_parentGuid=="111"?'':this.MenuListobjs.mu_parentGuid,
					mu_enable: this.radio == "1" ? true : false,
					mu_icon: this.MenuListobjs.mu_icon,
					mu_sort: this.MenuListobjs.mu_sort,
					mu_affiliation: "综合实训管理系统",
				}
				
				// console.log(MenuListobjs)
				// return
				if (this.MenuListobjs.mu_name_cn == "") {
					this.$message("菜单名不能为空")
				} else if (MenuListobjs.mu_name_en == "") {
					this.$message("菜单编号不能为空")
				} else {
					// console.log(MenuListobjs)
					getMenuInsertOrEdit(MenuListobjs).then(res => {
						// console.log(res)
						if (res.data.code == 1) {
							this.getmunelist()
							this.MenuListobjs = {}
							this.$message.success(res.data.msg)
							this.dialogVisible1 = false
							this.getnumanto()
							this.cdvalue = "111"
						} else {
							this.$message(res.data.msg)
						}
					})
				}

			},

			editxpri() {
				this.MenuListobj.mu_parentGuid = this.MenuListobj.mu_parentGuid ?? ""
				let MenuListobjs = {
					mu_guid: this.MenuListobj.mu_guid,
					mu_name_cn: this.MenuListobj.mu_name_cn,
					mu_name_en: this.MenuListobj.mu_name_en,
					mu_menuPath: this.MenuListobj.mu_menuPath,
					mu_parentGuid: this.MenuListobj.mu_parentGuid[0] == "111" ? "" : this.MenuListobj.mu_parentGuid,
					mu_enable: this.MenuListobj.mu_enable,
					mu_icon: this.MenuListobj.mu_icon,
					mu_sort: this.MenuListobj.mu_sort,
					mu_affiliation: "综合实训管理系统",
				}
				if (MenuListobjs.mu_name_cn == "") {
					this.$message("菜单名不能为空")
				} else if (MenuListobjs.mu_name_en == "") {
					this.$message("菜单编号不能为空")
				} else {
					// console.log(MenuListobjs)
					getMenuInsertOrEdit(MenuListobjs).then(res => {
						// console.log(res)
						if (res.data.code == 1) {
							this.$message.success(res.data.msg)
							this.dialogVisible = false
							this.getmunelist()
						} else {
							this.$message(res.data.msg)
						}
					})
				}


			},

			// 查看单个菜单数据
			looginmun(e) {
				getcdMenuSingle(e.mu_guid).then(res => {
					// console.log(res)
					if (res.data.code == 1) {
						this.dialogVisible = true
						this.MenuListobj = res.data.data
						this.titlefs = res.data.data.mu_affiliation + "菜单"
						this.looins = 1
					}
				})

			},
			// 获取菜单列表
			getmunelist() {
				// let MenuListobj = {
				// 	pageIndex: 1,
				// 	pageSize: 10,
				// 	mu_parentGuid: "",
				// 	mu_name_cn: ""
				// }
				getPcdageMenuList(this.pagesobj).then(res => {
					// console.log(res)
					if (res.data.code == 1) {
						this.tableData = res.data.data.list
						this.pagesobj.maxpages = res.data.data.totalCount
					} else {
						this.$message(res.data.msg);
					}
				})
			},
			handleClose() {
				// this.$confirm('确认关闭？')
				// 	.then(_ => {
				// 		// done();
				// 		this.dialogVisible1 = false
				// 		this.dialogVisible = false
				// 	})
				// 	.catch(_ => {
				// 		this.dialogVisible1 = false
				// 		this.dialogVisible = false
				// 	})
			},
			openordersetting() {
				this.dialogVisible1 = true
				this.cdvalue = "111"
			},
			handleNodeClick(data) {
				// console.log(data);
			},
			// 菜单删除
			tabledeletes(e, item) {
				// console.log(item)
				let deleobj = {

				}
				let mu_guid = [
					item.mu_guid
				]
				deleobj.mu_guid = mu_guid
				this.$confirm('此操作将删除这条记录，是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					AuthoriyMenuDeleteList(deleobj).then(res => {
						if (res.data.code == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getmunelist()

						} else {
							this.$message(res.data.msg)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});


			}

		},
		components: {
			titles
		}
	}
</script>

<style>
</style>
